module.exports = __webpack_public_path__ + "img/man.7d9891d1.png";